import React from 'react'
import { BookOpen, Braces, Lightbulb, MonitorPlay, PresentationIcon, Zap } from 'lucide-react'

export const guideContentTypes = [
  'fundamentals',
  'methods',
  'insights',
  'tutorials',
  'demos',
  'glossary',
] as const

export type GuideContentType = (typeof guideContentTypes)[number]

export const guideContentTypeLabels: Record<GuideContentType, string> = {
  fundamentals: 'Fundamentals',
  methods: 'Methods',
  insights: 'Insights',
  tutorials: 'Tutorials',
  demos: 'Demos',
  glossary: 'Glossary',
}

export const guideBadgeClassMap: Record<GuideContentType, string> = {
  fundamentals: 'bg-pink-200 text-pink-900 hover:bg-pink-200',
  methods: 'bg-lime-200 text-lime-900 hover:bg-lime-200',
  insights: 'bg-purple-100 text-purple-900 hover:bg-purple-100',
  tutorials: 'bg-yellow-100 text-yellow-900 hover:bg-yellow-100',
  demos: 'bg-green-100 text-green-900 hover:bg-green-100',
  glossary: 'bg-slate-100 text-slate-900 hover:bg-slate-100',
}

export const guideIconMap: Record<GuideContentType, React.ReactNode> = {
  fundamentals: React.createElement(MonitorPlay, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  methods: React.createElement(Braces, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  insights: React.createElement(Lightbulb, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  tutorials: React.createElement(BookOpen, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  demos: React.createElement(PresentationIcon, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
  glossary: React.createElement(BookOpen, { className: 'h-10 w-10', 'aria-hidden': 'true' }),
}
